import React, { FunctionComponent, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { TableHead, TableRow, TableCell } from "@material-ui/core";
import clsx from "clsx";
import TableHeaderItem from "./TableHeaderItem";
import { SortFields, SortOrder } from "model/User";

interface Props {
  onSort: (field: SortFields | undefined, order: SortOrder) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
    },
    cell: {
      paddingLeft: "0px",
      paddingTop: "0px",
      paddingRight: "0px",
      borderBottom: "1px solid #F1F1F1",
      borderTop: "1px solid #F1F1F1",
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "6px",
        paddingTop: "6px",
        fontSize: "5px",
      },
      [theme.breakpoints.only("md")]: {
        paddingBottom: "10px",
        paddingTop: "10px",
        fontSize: "8px",
      },
      [theme.breakpoints.only("lg")]: {
        paddingBottom: "13px",
        paddingTop: "13px",
        fontSize: "11px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingBottom: "20px",
        paddingTop: "20px",
        fontSize: "16px",
      },
    },
    businessName: {
      width: "24%",
      "&:hover": {
        cursor: "pointer",
        color: "#5E8677"
      },
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "10px",
      },
      [theme.breakpoints.only("md")]: {
        paddingLeft: "16px"
      },
      [theme.breakpoints.only("lg")]: {
        paddingLeft: "22px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: "33px",
      },
    },
    category: {
      width: "14%",
    },
    roleAndAccess: {
      width: "21%",
    },
    actions: {
      width: "10%",
      [theme.breakpoints.down("sm")]: {
        paddingRight: "19px",
      },
      [theme.breakpoints.only("md")]: {
        paddingRight: "30px"
      },
      [theme.breakpoints.only("lg")]: {
        paddingRight: "40px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingRight: "61px",
      },
    },
    impersonate: {
      width: "10%",
    },
  })
);

export const TableHeader: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  const [sortField, setSortField] = useState<SortFields | undefined>(undefined);
  const [sortOrder, setSortOrder] = useState<SortOrder | undefined>(undefined);

  const sortHandler = (field: SortFields | undefined, order: SortOrder) => {
    setSortField(field);
    setSortOrder(order);
    props.onSort(field, order);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell className={clsx(classes.cell, classes.businessName)}>
          <TableHeaderItem
            label="Business Name"
            sortField={SortFields.BUSINESS_NAME}
            sortOrder={sortField === SortFields.BUSINESS_NAME ? sortOrder : undefined}
            onSort={sortHandler}
          />
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.category)}>
          Category
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.roleAndAccess)}>
          Role
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.roleAndAccess)}>
          Access
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.impersonate)}>
          Impersonate
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.actions)}></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
